import React, { useState, useEffect } from 'react';
import IconSearch from '../assets/images/icons/IconSearch.svgr';
import ClearSearch from '../assets/images/icons/ClearSearch.svgr';

function SearchTopInput(props) {
    const {
        currentSearchTerm,
        results,

        searchFieldChange,
    } = props;
    const [term, setTerm] = useState(currentSearchTerm);
    const [inputState, setInputState] = useState('');

    let textInput;
    let searchButton;

    function updateUrl(text) {
        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?s=${term}`;
        window.history.replaceState(null, null, newUrl);
        const currentPageTitle = document.title;
        document.title = currentPageTitle.replace(
            currentPageTitle.match(/“(.*?)”/)[0],
            `“${term}”`
        );
    }

    function changeHandler(e) {
        e.preventDefault();
        setTerm(e.target.value);
    }

    function clearSearchInput(e) {
        if (e) {
            e.preventDefault();
        }
        setTerm('');
        setInputState('empty');
        textInput.focus();
    }

    function resetValue(e) {
        if (e.relatedTarget === searchButton) {
            return;
        }
        if (currentSearchTerm === '') {
            setInputState('empty');
        } else {
            setInputState('');
        }
        setTerm(currentSearchTerm);
    }

    function keyHandler(e) {
        setInputState('writting');
        if (e.key === 'Enter') {
            e.preventDefault();
            searchFieldChange(term);
            setInputState('');
            updateUrl(term);
        }
    }

    useEffect(() => {
        if (currentSearchTerm === '') {
            setInputState('empty');
        }
    }, [currentSearchTerm]);

    return (
        <div className="filter-search">
            <div className="filter-input" data-input-state={inputState}>
                <input
                    type="search"
                    placeholder="Search"
                    value={term}
                    onChange={(e) => {
                        changeHandler(e);
                    }}
                    onKeyUp={(e) => {
                        keyHandler(e);
                    }}
                    onBlur={(e) => resetValue(e)}
                    ref={(input) => {
                        textInput = input;
                    }}
                ></input>

                <button
                    className="clear-search clear-input"
                    onClick={(e) => {
                        clearSearchInput(e);
                    }}
                >
                    <ClearSearch />
                </button>

                <button
                    tabIndex={0}
                    className="search-button"
                    onMouseDown={(e) => e.preventDefault()}
                    onClick={(e) => {
                        searchButton.focus();
                        setInputState('');
                        searchFieldChange(term);
                        updateUrl(term);
                    }}
                    ref={(button) => {
                        searchButton = button;
                    }}
                >
                    <IconSearch />
                </button>
            </div>
            <p className="search-results-info">
                {results} {results === 1 ? 'Result' : 'Results'}
                {currentSearchTerm !== '' && ' for '}
                <span>{currentSearchTerm}</span>
            </p>
        </div>
    );
}

export default SearchTopInput;
